module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110266-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_110266-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_63"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674951_tableofcontents"
    }
  }, [_c('i', [_vm._v("1826")])])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_110266-00001"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("JANUARY ")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00001"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" A year has passd – another has commenced. These solemn divisions of time influence our feelings as they recur. Yet there is nothing in it – for every day in the year closes a twelve month as well as the 31st December. The latter is only the solemn pause as when a guide during a wild and mountainous road calls on a party to pause and look back at the scenes which they have just passd. To me this New Year opens sadly. There are these troublesome pecuniary difficulties which however I think this week should end. There is the absence of all my children, Anne excepted, from our little family festival. There is besides that ugly report of the 15 Hussars going to India. Walter I suppose will have some step in view and will go"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-373",
      "id": "num-footnote-1-373-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" and I fear Jane will not dissuade Him.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00002"
    }
  }, [_vm._v("A hard frosty day – cold but dry and pleasant under foot. Walkd into the plantations with Anne and Anne Russell. A thought strikes me allied to this period of the year. People say that the whole human frame in all its parts and divisions is gradually in the act of decaying and renewing. What a curious time-piece it would be that could indicate to us the moment this gradual and insensible change had so completely taken place that no atom was left of the original person who had existed at a certain period but there existed in his stead another person having the same limbs thewes and sinews, the same face and lineaments, the same consciousness – a new ship built on an old plank – A pair of transmigrated stockings like those of Sir John Cutler all green silk without one thread of the original black silk left! Singular – to be at once another and the same.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00001"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00003"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("2 MONDAY")]), _vm._v(" Weather"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-374",
      "id": "num-footnote-2-374-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" clearing up in Edinburgh once more and all will I believe do well. I am pressd to get on with "), _c('i', [_vm._v("Woodstock")]), _vm._v(" and must\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("try. I wish I could open a good vein of interest which would breathe freely. I must take my old way and write myself into goodhumour with my task. It is only when I dally with what I am about, look back and aside instead of keeping my eyes straight forward, that I feel these cold sinkings of the heart – All men I suppose do, less or more. They are like the sensation of a sailor when the ship is cleard for action and all are at their places – gloomy enough – but the first broadside puts all to rights.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("`\n\n\n         "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00004"
    }
  }, [_vm._v("Dined at Huntlyburn with the Fergussons en masse.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00002"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_64"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Promises a fair day and I think the progress of my labours will afford me a little exercize which I greatly need to help off the calomel feeling. Walkd with Colonel Russell from eleven till two, the first good day’s exercise I have had since coming here. We went through all the Terrace, the Roman planting, over by the Stell and Haxellcleuch"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-375",
      "id": "num-footnote-1-375-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" and so by the Rhymer’s glen to Chiefswood, which gave my heart a twinge so disconsolate it seemd. Yet all is for the best. Calld at Huntly Burn and shook hands with Sir Adam and his Lady just going off. When I returnd, signd the Bond for "), _c('i', [_vm._v("£")]), _vm._v("10,000 which will disencumber me of all pressing claims."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-376",
      "id": "num-footnote-2-376-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" When I get forwards "), _c('i', [_vm._v("W—k")]), _vm._v(" and "), _c('i', [_vm._v("Nap")]), _vm._v(". there will be "), _c('i', [_vm._v("£")]), _vm._v("12,000 and upwards, and I hope to add "), _c('i', [_vm._v("£")]), _vm._v("3000 against this time next year or the devil must hold [the] dice.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00006"
    }
  }, [_vm._v("J. B. writes me seriously on the carelessness of my style. I do not think I am more careless than usual but I dare say he is right. I will be more cautious.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00003"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00007"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Despatchd the deed yesterday executed. Yesterday Mr. and Mrs. Skene, my excellent friends, came to us from Edinburgh."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-377",
      "id": "num-footnote-3-377-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Skene, distinguishd for his attainments as a draughtsman and for his highly gentlemanlike feelings and character, is Laird of Rubislaw near Aberdeen. Having had an elder brother his education was somewhat neglected in early life, against which disadvantage he made a most gallant [fight] exerting himself much to obtain those accomplishments which [he] has since possessed. Admirable in all exercises there enterd a good deal of the cavalier into his early character. Of late he has given himself much to the study of antiquities. His wife, a most excellent person, was tenderly fond of Sophia. They bring so much oldfashioned kindness and good humour with them, besides the\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_65"
    }
  }, [_vm._v("recollections of other times, that they must be always wellcome guests. Letter from Mr. Scrope"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-378",
      "id": "num-footnote-1-378-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" announcing a visit.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00004"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00008"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Got the desired accomodation with Coutts which will put J. B. quite straight but am a little anxious still about Constable. He has immense stock to be sure and most valuable but he may have sacrifices to make to convert a large proportion of it into ready money. The accounts from London are most disastrous – many wealthy persons totally ruind and many many more have been obliged to purchase their safety at a price they will feel all their lives. I do not hear things are so bad in Edinburgh and J. B.’s business has been transacted by the Banks with liberality."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-379",
      "id": "num-footnote-2-379-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00009"
    }
  }, [_vm._v("Colonel Russell told us last night that the Last of the Moguls, a descendant of Kubla Khan though having no more power than his effigies at the back of a set of playing-cards, refused to meet Lord Hastings because the Governor General would not agree to remain standing in his presence. Pretty well for the blood of Timur in these degenerate days.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00010"
    }
  }, [_vm._v("Much alarmed. I had walkd till twelve with Skene and Colonel Russell and then sate down to my work. To my horror and surprize I could neither write nor spell but put down one word for another and wrote nonsense."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-380",
      "id": "num-footnote-3-380-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" I was much overpowerd at the same time and could not conceive the reason. I fell asleep however in my chair and slept for two hours. On waking my head was clearer and I began to recollect that last night I had taken the anodyne left for the purpose by Clarkson and being disturbd in the course of the night I had not slept it off.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00011"
    }
  }, [_vm._v("Received from the Corporation of Corke a very handsome silver snuff box with my freedom of that ancient city – Obliged to give up writing to-day – read Pepys"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-381",
      "id": "num-footnote-4-381-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" instead.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_c('br')])]), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_66"
    }
  }, [_vm._v("The Scotts of Harden were to have dined but sent an apology storm coming on. Russells left us this morning to go to Haining."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-382",
      "id": "num-footnote-1-382-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00005"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00013"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" This seems to be a feeding storm – coming on by little and little. Wrought all day and dined quiet. My disorder is wearing off and the quiet society of the Skenes suits with my present humour. I really thought I was in for some very bad illness. Curious expression of an Indian-born boy just come from Bengal, a son of my cousin George Swinton."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-383",
      "id": "num-footnote-2-383-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The child saw a hare run across the fields and exclaimd ‘See there is a little tiger.’\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00006"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("7"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" SATURDAY")]), _vm._v(" Sunday."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-384",
      "id": "num-footnote-3-384-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Knight,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-385",
      "id": "num-footnote-4-385-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" a young artist, son of the performer, came to paint my picture at the request of Terry"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-386",
      "id": "num-footnote-5-386-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" – This is very far from being agreeable as I submitted to this distressing state of constraint last year"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-387",
      "id": "num-footnote-6-387-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" – to Newton"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-388",
      "id": "num-footnote-7-388-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" at request of Lockhart, Leslie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-8-389",
      "id": "num-footnote-8-389-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" at request of my American friend,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-9-390",
      "id": "num-footnote-9-390-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Wilkie for his picture of the King’s arrival at Holy Rood House"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-10-391",
      "id": "num-footnote-10-391-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" and some one beside. I am as tired of the operation as old Maida"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-11-392",
      "id": "num-footnote-11-392-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" who had been so often sketchd that he got up and went away with signs of Loathing whenever he saw an artist unfurl his paper and handle his brushes. But this young man is civil and modest and I have agreed he shall sit in the room while I work and ta125ke the best likeness he can without compelling me into forced attitudes or the yawning fatigues of an actual sitting. I think if he has talent he may do more my way than in the customary mode – at least I cannot have the hangdog look which the unfortunate Theseus has who is doomd to sit for what seems an eternity."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-393",
      "id": "num-footnote-1-393-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00014"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_vm._v("I wrought till two o’clock, indeed till I was almost nervous with correcting and scribbling. I then walkd or rather was dragd through the snow by Tom Purdie while Skene accompanied. What a blessing there is in a man like Tom whom no familiarity can spoil, whom you may scold and praise and joke with, knowing the quality of the man is unalterable in his love and reverence to his master. Use an ordinary servant in the same way and he will be your master in a month.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110266-00015"
    }
  }, [_vm._v("We should thank God for the snow as well as summer-flowers. This brushing exercize has put all my nerves into tone again which were really jard with fatigue untill my very back-bone seemd breaking. This comes of trying to do too much.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00016"
    }
  }, [_vm._v("J.B.’ s news are as good as possible – prudence – prudence and all will do excellently.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00007"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_67"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Frost and snow still. Wrote to excuse myself from attending the funeral of my aunt Mrs. Curl which takes place tomorrow at Kelso. She was a woman of the old Sandyknow breed with the strong sense, high principle and indifferent temper which belongd to my father’s family. She lived with great credit on a moderate income and I believe gave away a great deal of it."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-394",
      "id": "num-footnote-2-394-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00008"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00018"
    }
  }, [_vm._v("9 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Matthews the Comedian and his son came to spend a day at Abbotsford."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-395",
      "id": "num-footnote-3-395-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The last is a clever young man with much of his father’s talent for mimicry. Rather forward though."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-396",
      "id": "num-footnote-4-396-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Mr. Scrope also came out which fills our house.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00019"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00009"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00020"
    }
  }, [_c('span', [_vm._v("10 ")]), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Bodily Health, the mainspring of the microcosm, seems quite restored. No more flinching or nervous fits but the sound mind in the sound body. What poor things does a fever fit or an overflowing of the bile make of the master of creation.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00002"
    }
  }, [_vm._v("The snow begins to fall thick this morning.")])]), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  }, [_c('p', [_vm._v("The Landlord then aloud did say")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_68"
    }
  }, [_vm._v("As how he wishd they would go away."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-397",
      "id": "num-footnote-1-397-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00002"
    }
  }, [_vm._v("To have our friends shut up here would be rather too much of a good thing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00021"
    }
  }, [_vm._v("The day cleard up and was very pleasant. Had a good walk and lookd at the curling. Mr. Matthews made himself very amusing in the evening. He has the goodnature to show his accomplishments without pressing and without the appearance of feeling pain. On the contrary I dare say he enjoys the pleasure he communicates."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-398",
      "id": "num-footnote-2-398-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00010"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00022"
    }
  }, [_vm._v("11 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" I got proof Sheets in which it seems I have repeated a whole passage of history which had been told before. James is in an awful stew and I cannot blame him. But then he should consider the hyasymus"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-399",
      "id": "num-footnote-3-399-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" which I was taking and the anxious botheration about the money market. However as Chaucer says\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00002"
    }
  }, [_c('p', [_vm._v("There is na workeman")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("That can bothe wirken wel and hastilie")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("This must be done at leisure parfaitly."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-400",
      "id": "num-footnote-4-400-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00023"
    }
  }, [_vm._v("Matthews, his son, Scrope and the Skenes still our guests.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00011"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00024"
    }
  }, [_vm._v("12 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Mathews last night gave us a very perfect imitation of Old Cumberland who carried the poetic jealousy and irritabi [lity] further than any man I ever saw."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-401",
      "id": "num-footnote-5-401-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" He was a great flatterer too, the old rogue. Will Erskine used to admire him. I think he wanted originality – a very high bred man in point of manners in Society.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00025"
    }
  }, [_vm._v("My little artist Knight gets on better with his portrait – the features are however too pinchd I think.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_69"
    }
  }, [_vm._v("Upon the matter, the days pass pleasantly enough – work till one or two, then an hour or two hours’ walk in the snow, then lighter work or reading. Late dinner"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-402",
      "id": "num-footnote-1-402-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" and singing or chat in the evening. Matthews has really all the will as well as the talent to be amusing. He confirms my idea of ventriloquism (which is an absurd word) as being merely the art of imitating sounds at a greater or less distance assisted by some little points of trick [ery] to influence the imagination of the audience. The vulgar idea of a peculiar organization (beyond fineness of ear and of utterance) is nonsense.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00012"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00028"
    }
  }, [_vm._v("13 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Our party are about to disperse.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00003"
    }
  }, [_c('p', [_vm._v("Like youthful steers unyoked east north and south."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-403",
      "id": "num-footnote-2-403-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00003"
    }
  }, [_vm._v("I am not sorry, being one of those whom too much mirth always inclines to sadness – the missing so many of my own family together with the serious inconveniences to which I have been exposed gave me at present a desire to be alone. The Skenes return to Edinburgh. So does Mr. Scrope – item the little artist – Matthews to New Castle, his son to Liverpool"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-404",
      "id": "num-footnote-3-404-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" – So "), _c('i', [_vm._v("exeunt omnes")]), _vm._v(".\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00029"
    }
  }, [_vm._v("Mathews assures me that Sheridan was generally very dull in society and sate sullen and silent swallowing glass after glass rather a hindrance than a help. But there was a time when he broke out with a resumption of what had been going on done with great force and generally attacking some person in the company or some opinion which he had expressd. I never saw Sheridan but in large parties. He had a Bardolph countenance with heavy features but his eye possessd the most distinguishd brilliancy. Mathews says it is very simple in Tom Moore to admire how Sheridan came by the means of paying the price of Drury Lane Theatre when all the world knows he never paid it at all and that Lacy who sold it was reduced to want by his breach of faith."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-405",
      "id": "num-footnote-4-405-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00030"
    }
  }, [_vm._v("Dined quiet with Anne, Lady Scott, and Gordon.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00031"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_70"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_70"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00013"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00032"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_70"
    }
  }, [_vm._v("14 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" An odd mysterious letter from Constable who is gone post to London to put something to rights which is wrong betwixt them, their banker and another monied friend. It strikes me to be that sort of letter which I have seen men write when they are desirous that their disagreeable intelligence should be rather apprehended than avowd. I thought he had been in London a fortnight ago disposing of property to meet this exigence and so I think he should. Well – I must have patience. But these tirrits and frights"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-406",
      "id": "num-footnote-1-406-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" are truly annoying. Luckily the funny people are gone and I will not have the task of grinning when I am serious enough.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00033"
    }
  }, [_vm._v("Dined as yesterday.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00034"
    }
  }, [_vm._v("A letter from J. B. mentioning Constable’s journey but without expressing much if any apprehension. He knows C. well and saw him before his departure and makes no doubt of his being able easily to extricate whatever may be entangled. I will not therefore make myself more uneasy than I can help doing so surely if I will. At least I have given up segars since the year began and have now no wish to return to the habit as it is calld. I see no reason why one should not be able to vanquish with God’s assistance these noxious thoughts which foretell evil but cannot remedy it.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00014"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00035"
    }
  }, [_vm._v("15 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Like yesterday a hard frost – thermometer at 10 yesterday was at 8½ to-day 12."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-407",
      "id": "num-footnote-2-407-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Water in my dressing room frozen to flint. Yet I had a fine walk yesterday, the sun shining delightfully on ‘grim nature’s visage hoar’."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-408",
      "id": "num-footnote-3-408-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Were it not the plague of being dragd along by another person I should like this weather as well as summer. But having Tom Purdie to do this office reconciles me to it – "), _c('i', [_vm._v("I cannot")]), _vm._v(" "), _c('i', [_vm._v("cleik")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-409",
      "id": "num-footnote-4-409-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('i', [_vm._v("with John")]), _vm._v(" as old Mrs. Muir used to say. I mean that an ordinary Menial servant thus hookd to your side reminds me of the twin bodies mentiond by Pitscottie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-410",
      "id": "num-footnote-5-410-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" being two trunks on the same waist and legs. One died before the other and remaind a dead burthen on the back of its companion. Such is the close union with a person whom you cannot well converse with and whose presence is yet indispensible to your getting on. An actual companion whether humble or your equal is still worse. But T. Purdie is just the thing, kneaded up between the\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_71"
    }
  }, [_vm._v("friend and servant as well as Uncle Toby’s Bowling Green"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-411",
      "id": "num-footnote-1-411-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" between sand and clay. You are certain he is proud as well as patient under his burthen and you are under no more constraint than with a poney. I must ride him to-day if the weather holds up. Meantime I will correct that curious fellow Pepys’ "), _c('i', [_vm._v("Diary")]), _vm._v(", I mean the article I have made of it for the "), _c('i', [_vm._v("Quarterly")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-412",
      "id": "num-footnote-2-412-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00015"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00036"
    }
  }, [_vm._v("16 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Came through cold roads to as cold news. Hurst and Robinson have sufferd a Bill of "), _c('i', [_vm._v("£")]), _vm._v("1000 to come back on Constable which I suppose infers the ruin of both houses. We will soon see. Constable it seems, who was to have set off in the last week of December, dawdled here till in all human probability his going or staying became a matter of mighty little consequence. He could not be there till Monday night and his resources must have come too late. Dined with the Skenes."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-413",
      "id": "num-footnote-3-413-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00016"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00037"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("17 TUESDAY")]), _vm._v(" James Ballantyne this morning, good honest fellow, with a visage as black as the crook. He hopes no salvation, has indeed taken measures to stop. It is hard after having fought such a battle. Have apologised attending the R. Society Club who have a Gaudeamus on this day and seemd to count much on my being the Praeses –\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00038"
    }
  }, [_vm._v("My old acquaintance Miss Eliz. Clerk, sister of Willie, dead suddenly. I cannot chuse but wish it had been S. W. S. and yet the feeling is unmanly. I have Anne, my wife, and Charles to look "), _c('a', {
    attrs: {
      "id": "pb-rw_72"
    }
  }, [_vm._v("after. I felt rather sneaking as I came home from the P. House,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-414",
      "id": "num-footnote-1-414-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" felt as if I were liable "), _c('i', [_vm._v("Monstrari digito")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-415",
      "id": "num-footnote-2-415-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" in no very pleasant way. But this must be born "), _c('i', [_vm._v("cum caeteris")]), _vm._v(", and thank God however uncomfortable I do not feel despondent.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00039"
    }
  }, [_vm._v("I have seen Cadell Ballantyne and Hogarth."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-416",
      "id": "num-footnote-3-416-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" All advise me to execute a trust of my property for payment of my obligations. So does John Gibson"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-417",
      "id": "num-footnote-4-417-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" and so I resolve to do. My wife and daughter are gloomy but yet patient. I trust by my hold on the works to make it every man’s interest to be very gentle with me. Cadell makes it plain that by patience they will in six months realize "), _c('i', [_vm._v("£")]), _vm._v("20,000, which can be attainable by no effort of their own.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00017"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00040"
    }
  }, [_vm._v("18 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" He that sleeps too long in the morning let him borrow the pillow of a debtor. So says the Spaniard and so say I. I had of course an indifferent night of it. I wish these two days were over. But the worst is over. The Bank of Scotland has behaved very well, expressing a resolution to serve Constable’s house and me to the uttermost, but as no one can say to what extent Hurst and Robinson’s failure may go borrowing would but linger it out."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-418",
      "id": "num-footnote-5-418-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00018"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00041"
    }
  }, [_vm._v("19 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" During yesterday I received several visits from friends. Skene, Colin McKenzie, who I am glad to see looks well, with every offer of Service. The Royal Bank also sent Sir John Hope and Sir H. Jardine"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-419",
      "id": "num-footnote-6-419-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" to offer to comply with my wishes. The advocate"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-420",
      "id": "num-footnote-7-420-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" came on the same errand. But I gave all the same answer that my intention was to put the whole into the hands of a trustee and to be contented with the event, and that all I had to ask was time to do so and to extricate my affairs. I was assured of every accomodation in this way. From all quarters I have had the same kindness. Letters from Constable and Robinson have arrived. The last persist in saying they will pay all and every body. They say moreover in a postscript that had Constable been in town ten days sooner all would have been well. When I saw him on 24th December he proposed starting in three days, but dallied God knows why in a kind of infatuation I think till things had got irretrieveably wrong. There would have been no want of support here and his stock under his own management would have made a return immensely greater than it can under any other. "), _c('i', [_vm._v("Now")]), _vm._v(" I fear the loss must be great as his fall will involve many of the country dealers who traded with him.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_73"
    }
  }, [_vm._v("I feel quite composed and determined to labour. There is no remedy. I guess (as Mathews makes his Yankees say) that we shall not be troubled with visitors and I "), _c('i', [_vm._v("calculate")]), _vm._v(" that I will not go out at all so what can I do better than labour? Even yesterday I went about making notes on "), _c('i', [_vm._v("Waverley")]), _vm._v(" according to Constable’s plan."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-421",
      "id": "num-footnote-1-421-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" It will do good one day. To-day when I lock this volume I go to "), _c('i', [_vm._v("W—k")]), _vm._v(". Heigho –\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00043"
    }
  }, [_vm._v("Knight came to stare at me to complete his portrait. He must have read a tragic page comparative to what he saw at Abbotsford.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00044"
    }
  }, [_vm._v("We dined of course at home, and before and after dinner I finish about 20 printed pages of "), _c('i', [_vm._v("Woodstock")]), _vm._v(" but to what effect others must judge. A painful scene after dinner and another after supper endeavouring to convince these poor dear creatures that they must not look for miracles but consider the misfortune as certain and only to be lessend by patience and labour.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00019"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00045"
    }
  }, [_vm._v("20 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Indifferent night – very bilious which may be want of exercize. A letter from Sir J. Sinclair whose absurd vanity leads him to thrust his finger into everyman’s pie proposing that the Hurst and Robinson should sell their prints, of which he says they have a large collection, by way of lottery like Boydell."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-422",
      "id": "num-footnote-2-422-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00004"
    }
  }, [_c('p', [_vm._v("In scenes like these which break our heart")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Comes Punch like you and lets a f—."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-423",
      "id": "num-footnote-3-423-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00046"
    }
  }, [_c('i', [_vm._v("Mais pourtant cultivons notre jardin")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-424",
      "id": "num-footnote-4-424-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" The publick favour is my only lottery. I have long enjoyd the foremost prize and something in my breast tells me my Evil Genius will not overwhelm me if I stand by myself. Why should I not? I have no enemies – many attachd friends –\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_74"
    }
  }, [_vm._v("the popular ascendancy which I have maintaind is of the kind which is rather improved by frequent appearances before the public. In fact Critics may say what they will but ‘"), _c('i', [_vm._v("hain")]), _vm._v(" your reputation and "), _c('i', [_vm._v("tyne")]), _vm._v(" your reputation’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-425",
      "id": "num-footnote-1-425-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" is a true proverb.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00047"
    }
  }, [_vm._v("Sir William Forbes"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-426",
      "id": "num-footnote-2-426-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" calld, the same kind honest friend as ever, with all offers of assistance etc. etc. etc. All anxious to serve me and careless about their own risk of loss – And these are the cold, hard, money making men whose questions and Controul I apprehended.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00048"
    }
  }, [_vm._v("Lord Ch: Commissioner Adam"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-427",
      "id": "num-footnote-3-427-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" also came to see me and the meeting though pleasing was melancholy. It was the first time we have met since the "), _c('i', [_vm._v("break-up")]), _vm._v(" of his hopes in the death of his eldest son"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-428",
      "id": "num-footnote-4-428-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" on his return from India where [he] was Chief in Council and highly esteemd. Lord C. C. is not a very early friend of mine for I scarce knew him till his settlement in Scotland with his present office. But I have since lived much with him and taken kindly to him as one of the most pleasant, kind hearted, benevolent and pleasing men I have ever known. It is high treason among the Tories to express regard for him or respect for the Jury Court in which he prescribes. I was against that experiment as much as any one. But it is an experiment, and the establishment (which the fools will not perceive) is the onlything which I see likely to give some prospects of ambition to our bar which has been diminishd otherwise so much. As for the Chief Commissioner I dare say he jobs as all other people of consequence\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_75"
    }
  }, [_vm._v("do in elections and so forth. But he is the personal friend of the King and the decided enemy of whatever strikes at the constitutional rights of the Monarch. Besides I love him for the various changes which he has endured through life and which have been so great as to make him entitled to be regarded in one point of view as the most fortunate in the other the most unfortunate man in the world. He has gaind and lost two fortunes by the same good fortune and the same rash confidence which has raised and now threatens my "), _c('i', [_vm._v("peculium")]), _vm._v(". And his quiet, noble and generous submission under circumstances more painful than mine, for the loss of world’s wealth was aggravated by the death of his youngest and darling son in the West Indies, furnishd me at the time and now with a noble example – So the Tories and Whigs may go be damnd together as names that have distracted Old Scotland and torn asunder the most kindly feelings since the first day they were invented. Yetd—nthem they are spells to rouse all our angry passions, and I dare say notwithstanding the opinion of my private and calm moments I will open on the cry again so soon as something occurs to chafe my mood. And yet God knows I would fight in honourable contest with word or blow for my political opinions but I cannot permit that strife to ‘mix its waters with my daily meal’,"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-429",
      "id": "num-footnote-1-429-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" those waters of bitterness which poison all mutual love and confidence betwixt the well disposed on each side, and prevent them if need were from making mutual concessions and balancing the constitution against the Ultras of both parties. The good man seems something broken by these aflictions.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00020"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-cont_110266-00008"
    }
  }, [_vm._v("21 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Susannah in "), _c('i', [_vm._v("Tristram Shandy")]), _vm._v(" thinks Death is best met in bed."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-430",
      "id": "num-footnote-2-430-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" I am sure trouble and vexation is not. The watches of the night pass wearily when disturbd by fruitless regrets and disagreeable anticipations. But let it pass.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00005"
    }
  }, [_c('p', [_vm._v("Well Goodman Time or blunt or keen")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Move thou quick or take thy leisure")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Longest day will have its een")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Weariest life but treads a measure."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-431",
      "id": "num-footnote-3-431-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00049"
    }
  }, [_vm._v("I have seen Caddell"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-432",
      "id": "num-footnote-4-432-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" who is very much downcast for the risque of their copy-rights being thrown away by a hasty sale. I suggested that if they went very cheap some means might be fallen on to keep up their\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_76"
    }
  }, [_vm._v("value or purchase them in. I fear the split betwixt Constable and Caddell"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-433",
      "id": "num-footnote-1-433-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" will render impossible what might otherwise be hopeful enough. It is the Italian race-horses, I think, which instead of riders have spurs tied to their sides so as to prick them into a constant gallop. Caddell tells me their gross profit was sometimes "), _c('i', [_vm._v("£")]), _vm._v("10,000 a year but much swallowd up with expences and his partner’s draugh [t] s which came to "), _c('i', [_vm._v("£")]), _vm._v("4000 yearly. What there is to show for this God knows. Constable’s apparent expences were very much within bounds.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00050"
    }
  }, [_vm._v("Colin McKenzie enterd and with his usual kindness engages to use his influence to recommend some moderate proceeding to Constable’s crers which may permit him to go on and turn that species of property to account which no man alive can manage so well as he."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-434",
      "id": "num-footnote-2-434-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00051"
    }
  }, [_vm._v("Followd Mr. Gibson with a most melancholy tale. Things are so much worse with Constable than I apprehended that I shall neither save Abbotsford nor any thing else – Naked we enterd the world and naked we leave it. Blessed be the name of the Lord."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-435",
      "id": "num-footnote-3-435-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00021"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00004"
    }
  }, [_c('span', [_vm._v("22 ")]), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" I feel neither dishonourd nor broken down by the bad – miserably bad news I have received. I have walkd my last on the domains I have planted, sate the last time in the halls I have built. But death would have taken them from me if misfortune had spared them. My poor people whom I loved so well!! There is just another dye to turn up against me in this run of ill luck – i.e. If I should break my magic wand in a fall from this elephant and lose my popularity with my fortune. Then "), _c('i', [_vm._v("Woodstock")]), _vm._v(" and "), _c('i', [_vm._v("Boney")]), _vm._v(" may both go to the papermaker and I may take to smoking cigars and drinking grog or turn devotee and intoxicate the brain another way. In prospect of absolute ruin I wonder if they would let me leave the Court of Session. I should like methinks to go abroad\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00052"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_77"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_77"
    }
  }), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_77"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_77"
    }
  }, [_vm._v("And lay my banes far from the Tweed."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-436",
      "id": "num-footnote-1-436-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00053"
    }
  }, [_vm._v("But I find my eyes moistening and that will not do. I will not yield without a fight for it. It is odd, when I set myself to work "), _c('i', [_vm._v("doggedly")]), _vm._v(" as Dr. Johnson would say,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-437",
      "id": "num-footnote-2-437-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" I am exactly the same man that I ever was – neither low spirited nor "), _c('i', [_vm._v("distrait")]), _vm._v(". In prosperous times I have sometimes felt my fancy and powers of language flag – but adversity is to me at least a tonic and bracer – the fountain is awakend from its inmost recesses as if the spirit of afliction had troubled it in his passage.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00054"
    }
  }, [_vm._v("Poor Mr. Pole the harper sent to offer me "), _c('i', [_vm._v("£")]), _vm._v("500 or "), _c('i', [_vm._v("£")]), _vm._v("600, probably his all."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-438",
      "id": "num-footnote-3-438-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" There is much good in the world after all. But I will involve no friend either rich or poor – My own right hand shall do it – Else will I be "), _c('i', [_vm._v("done")]), _vm._v(" in the slang language and "), _c('i', [_vm._v("undone")]), _vm._v(" in common parlance.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00055"
    }
  }, [_vm._v("I am glad that beyond my own family, who are excepting L. S."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-439",
      "id": "num-footnote-4-439-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" young and able to bear sorrow of which this is the first taste to some of them, most of the hearts are past aching which would have been inconsolable on this occasion. I do not mean that many will not seriously regret and some perhaps lament my misfortunes. But my dear mother, my almost sister Christy R—d,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-440",
      "id": "num-footnote-5-440-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" – poor Will: Erskine – these would have been mourners indeed –\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00056"
    }
  }, [_vm._v("Well – exertion – exertion – O Invention rouze thyself. May man be kind – may God be propitious. The worst is I never quite know when I am right or wrong and Ballantyne, who does know in some degree, will fear to tell me. Lockhart would be worth gold just now but he too would be too diffident to speak broad out. All my hope is in the continued indulgence of the public.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00057"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_78"
    }
  }, [_vm._v("I have a funeral letter to the burial of the Chevalier Yelin, a foreigner of learning and talent, who has died at the Royal Hotel. He wishd to be introduced to me and was to have read a paper before the Royal Society when this introduction was to have taken place. I was not at the society that evening"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-441",
      "id": "num-footnote-1-441-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" and the poor gentleman was taken ill in the meeting and unable to proceed. He went to his bed and never arose again – and now his funeral will be the first public place that I shall appear at – he dead and I ruind. This is what you call a meeting.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00022"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00058"
    }
  }, [_vm._v("23 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Slept ill not having been abroad these eight days. "), _c('i', [_vm._v("Splendida bilis")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-442",
      "id": "num-footnote-2-442-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" Then a dead sleep in the morning and when the awakenings came a strong feeling how well I could dispence with it for once and for ever. This passes away however as better and more dutiful thoughts arise in my mind.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00059"
    }
  }, [_vm._v("I know not if my imagination has flaggd – probably it has but at least my powers of labour have not diminishd during the last melancholy week. On Monday and tuesday my exertions were suspended. Since Wednesday inclusive I have written thirty eight of my close manuscript pages of which seventy make a volume of the usual novel size.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00060"
    }
  }, [_vm._v("Wrote till twelve a.m. finishing half of what I call a good day’s work, ten pages of print or rather twelve. Then walkd in the Princes Street pleasure grounds"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-443",
      "id": "num-footnote-3-443-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" with good Samaritan James Skene,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-444",
      "id": "num-footnote-4-444-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" the only\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_79"
    }
  }, [_vm._v("one among my numerous friends who can properly be termd "), _c('i', [_vm._v("amicus")]), _vm._v(" "), _c('i', [_vm._v("omnium horarum")]), _vm._v(","), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-445",
      "id": "num-footnote-1-445-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" others being too busy or too gay and several being estranged by habit. The walks have been conducted on the whole with much taste though Skene has undergone much criticism,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-446",
      "id": "num-footnote-2-446-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" the usual reward of public exertions, on account of his plans. It is singular to walk close beneath the grim old Castle and think what scenes it must have seen and how many generations of three score and ten have risen and past away. It is a place to cure one of too much sensation over earthly subjects of mutation. My wife and girl’s tongues are chatting in a lively manner in the drawing-room. It does me good to hear them.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00023"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00061"
    }
  }, [_vm._v("24 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Constable came yesterday and saw me for half an hour. He seemd irritable but kept his temper under command. Was a little shockd when I intimated that I was disposed to regard the present works in progress as my own. I think I saw two things – 1. That he is\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_80"
    }
  }, [_vm._v("desirous to return in to the management of his own affairs without Cadell if he can. 2. That he relies on my connexion as the way of helping us out of the slough. Indeed he said he was ruind utterly without my countenance. I certainly will befriend him if I can but Constable without Cadell is like getting the clock without the pendulum – the one having the ingenuity – the other the caution of the business – I will see my way before making any bargain, and I will help them I am sure if I can without endangering my last cast for freedom. Workd out my task yesterday.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_80"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00062"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_80"
    }
  }, [_vm._v("My kind friend Mrs. Coutts has got the cadetship for Pringle Shortreed"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-447",
      "id": "num-footnote-1-447-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" in which I was peculiarly interested.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00063"
    }
  }, [_vm._v("I went to the Court for the first time to-day and like the man with the large nose thought everybody was thinking of me and my mishaps. Many were undoubtedly and all rather regrettingly, some obviously affected. It is singular to see [the] difference of men’s manner whilst they strive to be kind or civil in their way of addressing me. Some smiled as they wishd me good day as if to say ‘Think nothing about it my lad; it is quite out of our thoughts –’ Others greeted me with the affected gravity which one sees and despises at a funeral. The best-bred, all I believe meaning equally well, just shook hands and went on."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-448",
      "id": "num-footnote-2-448-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00064"
    }
  }, [_vm._v("A foolish puff in the papers calling on men and gods to assist a popular author who having choused the public of many thousands had not the sense to keep wealth when he had it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00065"
    }
  }, [_vm._v("If I am hard pressd and measures used against me I must use all measures of legal defence and subscribe myself bankrupt in a petition for sequestration. It is the course I would have advised a client to take and would have the effect of saving my land, which is secured by my "), _c('a', {
    attrs: {
      "id": "pb-rw_81"
    }
  }, [_vm._v("son’s contract of marriage. I might save my library etc. by assistance of friends and bid my creditors defiance. But for this I would in a court of Honour deserve to lose my spurs for – No, if they permit me, I will be their vassal for life and dig in the mine of my imagina [tion] to find diamonds (or what may sell for such) to make good my engagements, not to enrich myself. And this from no reluctance to allow myself to be calld the Insolvent which I probably am but because I will not put out of the [reach] of my creditors the resources mental or literary which yet remain to me."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-449",
      "id": "num-footnote-1-449-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00066"
    }
  }, [_vm._v("Went to the funeral of Chevalier Yelin, the literary foreigner mentiond on 22d. How many and how various are the ways of afliction. Here is this poor man dying at a distance from home, his friend"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-450",
      "id": "num-footnote-2-450-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" heart-broken, his wife and family anxiously expecting letters and doomd only to learn they have lost a husband and father for ever. He lies buried on the Calton hill"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-451",
      "id": "num-footnote-3-451-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" near learnd and scientific dust – the graves of David Hume"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-452",
      "id": "num-footnote-4-452-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" and John Playfair"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-453",
      "id": "num-footnote-5-453-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" being side by side.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00024"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00067"
    }
  }, [_vm._v("25 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Anne is ill this morning – May God help us; if it should prove serious as I have known it in such cases where am I to find courage or comfort?\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00001"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("24J. B.\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00068"
    }
  }, [_vm._v("A thought has struck me – can we do nothing for ourselves with the goblin drama calld the "), _c('i', [_vm._v("Fortunes of Devorgoil")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-454",
      "id": "num-footnote-6-454-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" – Could it not be added to "), _c('i', [_vm._v("Woodstock")]), _vm._v(" as a fourth volume? – Terry refused a gift of it but he was quite and entirely wrong – It is not good but it may be made so – Poor Will Erskine liked it much. Gave my wife her "), _c('i', [_vm._v("£")]), _vm._v("12 allowance. "), _c('i', [_vm._v("£")]), _vm._v("24 to last till Wednesday fort-night."), _c('i', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00025"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00069"
    }
  }, [_vm._v("26 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" Spoke to J. B. last night about "), _c('i', [_vm._v("Devorgoil")]), _vm._v(" who does not seem to relish the proposal, alleging the comparative failure of "), _c('i', [_vm._v("Halidon")]), _vm._v(" "), _c('i', [_vm._v("Hill")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-455",
      "id": "num-footnote-7-455-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" Aye, says Self conceit, but he has not read it – and when he does it is the sort of wild fanciful work betwixt heaven and earth which men of solid parts do not estimate. Pepys thought Shakespeare’s "), _c('i', [_vm._v("Midsummer’s")]), _vm._v(" "), _c('i', [_vm._v("Night’s Dream")]), _vm._v(" the most silly play he had ever seen and Pepys was probably judging on the same grounds with J. B. though presumptuous enough to form conclusions against a very different work from any of mine. How if I send it to Lockhart by and bye?\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00071"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_82"
    }
  }, [_vm._v("I calld to-day at Constable’s. Both partners seemd secure that Hurst and Robinson were to go on and pay. Strange that they should have stopd. Constable very anxious to have husbanding of the books. I told him the truth that I would be glad to have his assistance – and that he should have the benefit of the agency but that he was <not> to consider past transactions as no rule for settling those in future since I must needs make the most out of the labours I could: item, that I or whoever might act for me would of course after what has happend look especially to the security. He said if Hurst and Robinson were to go on bank notes would be laid down. I conceive indeed that they would take "), _c('i', [_vm._v("W")]), _vm._v("—"), _c('i', [_vm._v("k")]), _vm._v(" and "), _c('i', [_vm._v("Napoleon")]), _vm._v(" almost at loss rather than break the connection in the public eye.\n         ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_82"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00002"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("6 5\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("   1 1")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_82"
    }
  }, [_vm._v("Sir William Arbuthnot and Mr. Kinnear"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-456",
      "id": "num-footnote-1-456-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" were very kind. But cui "), _c('i', [_vm._v("bono")]), _vm._v("?"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-457",
      "id": "num-footnote-2-457-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Received "), _c('i', [_vm._v("£")]), _vm._v("6.5. paid back of deposit for Wool stapling Stock Coy. Gave it to my wife with direction to repay Anne "), _c('i', [_vm._v("£")]), _vm._v("1.1.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00073"
    }
  }, [_vm._v("Gibson comes with a joyful face announcing all the Creditors had unanimously agreed to a private trust."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-458",
      "id": "num-footnote-3-458-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" This is handsome and\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_83"
    }
  }, [_vm._v("confidential and must warm my best efforts to get them out of the scrape. I will not doubt – to doubt is to lose. Sir William Forbes took the chair and behaved as he has ever done with the generosity of ancient faith and early friendship. They"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-459",
      "id": "num-footnote-1-459-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" are deeper concernd than most. In what scenes have Sir William and I not born share together – desperate and almost bloody affrays, rivalries – deep drinking matches, and finally with the kindest feelings on both sides somewhat separated by his retiring much within the bosom of his family and I moving little beyond mine. It is fated our planets should cross though and that at the period most interesting for me – Down – down – a hundred thoughts. – Jane Russel drank tea with us.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00074"
    }
  }, [_vm._v("I hope I will sleep better to-night. If I do not I shall get ill and then I cannot keep my engagements. Is it not odd? I can command my eyes to be awake when toil and weariness sit on my eyelids but to draw the curtain of oblivion is beyond my power. I remember some of the wild Buccaneers in their impiety succeeded pretty well by shutting hatches and burning brimstone and assafœtida to make a tolerable imitation of "), _c('i', [_vm._v("hell")]), _vm._v(" but their "), _c('i', [_vm._v("heaven")]), _vm._v(" was a wretched affair – It is one of the worst things about this system of ours that it is a hundred times more easy to inflict pain than to create pleasure.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00026"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00075"
    }
  }, [_vm._v("27 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Slept better and less bilious owing doubtless to the fatigue of the preceding night and the more comfortable news."), _c('i', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00003"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("136\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I drew my salaries of various kinds amounting to "), _c('i', [_vm._v("£")]), _vm._v("300 and upwards ("), _c('i', [_vm._v("£")]), _vm._v("336 including cash due for su [r]-plusages to county) and sent with John Gibson’s consent "), _c('i', [_vm._v("£")]), _vm._v("200 to pay off things at Abbotsford which must be paid. Wrote Laidlaw with the money directing him to make all preparations for reduction."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-460",
      "id": "num-footnote-2-460-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _c('i', [_c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00004"
    }
  }, [_vm._v("Anne ill of Rheumatism – I believe caught cold by vexation and exposing herself to bad weather.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00077"
    }
  }, [_vm._v("The Celtic Society present me with the most splendid broadsword I ever saw. A beautiful piece of art and a most noble weapon. Honble Mr. Stewart (2d son of the Earl of Moray) General Graham Stirling and MacDougal"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-461",
      "id": "num-footnote-3-461-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" attended as a committee to present it. This was very kind of my friends the Celts by whom I have had so many merry meetings. It will be a rare legacy to Walter; for myself, good lack, it is like Lady Dowager Don’s prize in a lottery of hardware, she, being a venerable lady who always wore a haunch-hoop silk negligee and triple rufles at the elbow, having the luck to gain a pair of silver spurs and a whip to correspond.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00078"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_84"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_84"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00027"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00079"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_84"
    }
  }, [_vm._v("28 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Ballantyne and Cadell wish that Mr. Alexr. Cowan should be Constable’s trustee instead of J. B.’ s. Gibson is determined to hold by Cowan. I will not interpose although I think Cowan’s services might do us more good as Constable’s trustee than as our own."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-462",
      "id": "num-footnote-1-462-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(" But I will not begin with thwarting the managers of my affairs or even exerting strong influence. It is not fair. These last four or five days I have wrought little; to-day I set on the steam and ply my paddles.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00028"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00080"
    }
  }, [_vm._v("29 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" The proofs of vol. I"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-463",
      "id": "num-footnote-2-463-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" came so thick in yesterday that much was not done. But I begin to be hard at work to-day and must not "), _c('i', [_vm._v("gurnalize")]), _vm._v(" much.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00081"
    }
  }, [_vm._v("Mr. Jollie, who is to be my trustee in conjunction with Gibson, came to see me – a pleasant and goodhumourd man and has high reputation as a man of business."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-464",
      "id": "num-footnote-3-464-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" I told him and I will keep my word that he would at least have no trouble by my interfering and thwarting their management"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-465",
      "id": "num-footnote-4-465-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" which is the not unfrequent case of trusters and trustees.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00082"
    }
  }, [_vm._v("Constable’s business seems unintelligible. No man thought the house worth less than "), _c('i', [_vm._v("£")]), _vm._v("150,000 – Constable told me when he was making his will that he was worth "), _c('i', [_vm._v("£")]), _vm._v("80,000. Great profits on almost all their adventures. No bad speculations yet neither stock nor debt to show. Constable might have eat up his share but Cadell was very frugal – No doubt trading almost entirely on accomodation is dreadfully expensive.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00029"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00083"
    }
  }, [_vm._v("30 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" "), _c('i', [_vm._v("False delicacy")]), _vm._v(". Mr. Gibson, Mr. Cowan, and Mr. J. B., were with me last night to talk over important matters and suggest an\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_85"
    }
  }, [_vm._v("individual for a certain highly confidential situation. I was led to mention a person of whom I knew nothing but that he was an honest and intelligent man. All seemd to acquiesce and agreed to move the thing to the party concernd this morning and so Mr. G. and Mr. C. left me, when J. B. let out that it was their unanimous opinion that we should be in great trouble were the individual appointed from faults of temper etc. which would make it difficult to get on with him. With a hearty curse I hurried J. B. to let them know that I had no partiality for the man whatever and only named him because he had been proposed for a similar situation elsewhere. This is provoking enough that they would let me embarass my affairs with a bad man (an unfit one I mean) rather than contradict me. I dare say great men are often used so.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_85"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_110266-00084"
    }
  }, [_vm._v("I labourd freely yesterday. The stream rose fast – if clearly is another question but there is bulk for it at least, about 30 printed pages.")])]), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_85"
    }
  }), _c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_85"
    }
  }, [_vm._v("And now again boys to the Oar."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-466",
      "id": "num-footnote-1-466-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00085"
    }
  }, [_vm._v("31 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" There being nothing in the Roll to-day I stay at home from the Court and add another day’s perfect labour to "), _c('i', [_vm._v("Woodstock")]), _vm._v(" which is worth five days of snatched intervals when the current of thought and invention is broken in upon and the mind shaken and diverted from its purpose by a succession of petty interr-uptions. I have now no pecuniary provisions to embarass me, and I think now the shock of the discovery is past and over I am much better off on the whole. I am as if I had shaken off from my shoulders a great mass of garments rich indeed but cumbrous and always more a burthen than a comfort. I am free of an hundred petty public duties imposed on me as a man of consideration, of the expense of a great hospitality, and what is better of the great wast [e] of time connected with it. I have known in my day all kinds of society and can pretty well estimate how much or how little one loses by retiring from all but that which is very intimate. I sleep and eat and work as I am wont and, if I could see those about me as indifferent to the loss of rank as I am I should be completely happy. As it is time must salve that sore, to time I trust it.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00086"
    }
  }, [_vm._v("Since the 16th of this month no guest has broken bread in my house save G. H. Gordon"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-467",
      "id": "num-footnote-2-467-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" one morning at Breakfast. This happend never before since I had a house of my own. But I have plaid Abou\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_86"
    }
  }, [_vm._v("Hassan long enough and if the Caliph comes I would turn him back again."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-468",
      "id": "num-footnote-1-468-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "rw-h2_110266-00002"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("FEBRUARY")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00087"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" A most generous letter (though not more so than I expected) from Walter and Jane offering to interfere with their fortune etc."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-469",
      "id": "num-footnote-2-469-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" God Almighty forbid – that were too unnatural in me to accept tho’ dutiful and affectionate in them to offer. They talk of India still – with my damaged fortune I cannot help them to remain by exchange and so forth. He expects if they go to go out eldest Captain, when by staying two or three years he will get the step of Major."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-470",
      "id": "num-footnote-3-470-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" His whole thoughts are with his profession and I understand that when you quit or exchange when a regiment goes on\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_87"
    }
  }, [_vm._v("distant or disagreeable service you are not accounted as serious in your profession. God send what is for the best.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_87"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00088"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_87"
    }
  }, [_vm._v("Remitted Charles a bill for "), _c('i', [_vm._v("£")]), _vm._v("40. "), _c('i', [_vm._v("£")]), _vm._v("35 advanced at Christmas makes "), _c('i', [_vm._v("£")]), _vm._v("75. He must be frugal."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-471",
      "id": "num-footnote-1-471-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("Attended the court and saw J. B. and Cadell as I returnd. Both very gloomy. Came home to work etc. about two.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00030"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00089"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" An odd visit this morning from Miss Jane Bell of North Shields whose law suit with a Methodist parson of the name of Hill made some noise."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-472",
      "id": "num-footnote-2-472-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" The worthy divine had in the basest manner interfered to prevent this lady’s marriage by two anonymous letters in which he contrived to refer the lover to whom they were address [d] for further corroboration to "), _c('i', [_vm._v("himself")]), _vm._v(". The whole imposture makes the subject of a little pamphlet publishd by Marshall of NewCastle. The Lady ventured for redress into the thicket of English law – lost one suit – gaind another with "), _c('i', [_vm._v("£")]), _vm._v("300 damages and was ruind. The appearance and person of Miss Bell is prepossessing. She is about thirty years old, a brunette with regular and pleasing features markd with melancholy – an enthusiast in literature and probably in religion. She had been at Abbotsford to see me and made her way to me here in the vain hope that she could get her story workd up into a novel and certainly the thing is capable of interesting situations. It throws a curious light upon the aristocratic or rather Hierocratic influence exercised by the Methodist preachers within the Connexion as it is calld. Admirable food this would be [for] the Quarterly or any other reviewers who might desire to feed fat their grudge against this sept."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-473",
      "id": "num-footnote-3-473-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" But there are two reasons against such a vindication. First it would do the poor sufferer no good. 2dly. It would hurt the Methodistic Connexion very much which I for one would not like to injure. They have their faults and are peculiarly liable to those of hypocrisy and spiritual ambition and priest-craft. On the other hand they do infinite good, carrying religion into classes in Society where it would scarce be found to penetrate did it rely merely upon proof of its\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_88"
    }
  }, [_vm._v("doctrines upon calm reasons and upon rational argument. To these the Methodists add a powerful appeal to the feelings and passions and though I believe this is often exaggerated into absolute enthusiasm yet I consider upon the whole they do much to keep alive a sense of religion and the practice of morality necessarily connected with it. It is much to the discredit of the Methodist clergy that when the villainous calumniator was actually convicted of guilt morally worse than many men are hangd for they only degraded him from the first to the second class of their preachers, leaving a man, who from mere hatred at Miss Bell’s brother who was a preacher like himself had proceeded in such a deep and infamous scheme to ruin the character and destroy the happiness of an innocent person, in possession of the pulpit and an authorized teacher of others. If they believed him innocent they did too much, if guilty far too little.\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_88"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00090"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_88"
    }
  }, [_vm._v("I wrote to my Nephew Walter"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-474",
      "id": "num-footnote-1-474-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" to-day cautioning him against a little disposition which he has to satire or "), _c('i', [_vm._v("méchanceté")]), _vm._v(" which may be a great stumbling block in his career in life – Otherwise I presage well of him. He is Lieutenant of Engineers with high character for math-ematical science – is acute – very well mannerd and I think good-hearted. He has seen enough of the world too to regulate his own course through life better than most lads at his age.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00031"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00091"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" This is the first morning since my troubles that I felt at awaking\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00008"
    }
  }, [_c('p', [_vm._v("I had drunken deep")]), _vm._v(" "), _c('p', [_vm._v("Of all the blessedness of sleep."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-475",
      "id": "num-footnote-2-475-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00005"
    }
  }, [_vm._v("I made not the slightest pause nor dreamd a single dream nor even changed my side. This is a blessing to be grateful for. There is to be a meeting of the Creditors to-day but I care not for the issue. If they drag me into the Court "), _c('i', [_vm._v("obtorto collo")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-476",
      "id": "num-footnote-3-476-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" instead of going into this scheme of arrangement they will do themselves a great injury and perhaps eventually do me good though it would give me much pain.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00092"
    }
  }, [_vm._v("J. B. is severely critical on what he calls imitations of Mrs. "), _c('a', {
    attrs: {
      "id": "pb-rw_89"
    }
  }, [_vm._v("Radcliffe in "), _c('i', [_vm._v("Woodstock")]), _vm._v(" – many will think with him – yet I am of opinion he is quite wrong or, as friend J. F."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-477",
      "id": "num-footnote-1-477-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" says, "), _c('i', [_vm._v("vrong")]), _vm._v(". In the first place I am to look on the mere fact of another author having treated a subject happily as a bird looks on a potatoe bogle"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-478",
      "id": "num-footnote-2-478-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" which scares it away from a field otherwise as free to its depredations as any one’s else. In 2d place I have taken a wide difference – my object is not to excite fear of supernatural things in my reader but to show the effect of such fear upon the agents in the story – one a man of sense and firmness, one a man unhinged by remorse – one a stupid unin-quiring clown – one a learnd and worthy but superstitious divine. In 3d. place the book turns on this hinge and cannot want it. But I will try to insinuate the refutation of Aldiboronti’s"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-479",
      "id": "num-footnote-3-479-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" exception into the prefatory matter.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00093"
    }
  }, [_vm._v("From the 19 January to the 2d. february inclusive is exactly fifteen days during which time (with the intervention of some days’ idleness to let imagination brood on the task a little) I have written a volume. I think for a bett I could have done it in ten days. Then I must have had no court of Session to take me up two or three hours every morning and dissipate my attention and powers of working for the rest of the day. A volume at cheapest is worth "), _c('i', [_vm._v("£")]), _vm._v("1000. This is working at the rate of "), _c('i', [_vm._v("£")]), _vm._v("24,000 a year, but then we must not bake bunns faster than people have appetite to eat them. They are not essential to the market like potatoes.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00094"
    }
  }, [_vm._v("John Gibson came to tell me in the evening that a Meeting to-day had approved of the proposed trust. I know not why but the news gave me little concern. I heard it as a party indifferent. I remember hearing that Mandrin"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-480",
      "id": "num-footnote-4-480-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" testified some horror when he found himself bound alive on the wheel and saw an executioner approach with a bar of iron to break his limbs. After the second and third blow he fell a laughing and being askd the reason by his confessor said he laughd at his own folly which had anticipated increased agony at every blow when it was obvious that the "), _c('i', [_vm._v("first")]), _vm._v(" must have jarrd and confounded the system of the nerves so much as to render the succeeding blows of little consequence. I suppose it is so with the moral feeling – At least I could not bring myself to be anxious whether these matters were settled one way or other.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00095"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_90"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_90"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00032"
    }
  })]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_90"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Wrote to Mr. Laidlaw"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-481",
      "id": "num-footnote-1-481-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")]), _vm._v(" to come to town on Monday and see the trustees. To farm or not to farm is the question."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-482",
      "id": "num-footnote-2-482-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" With our careless habits it were best I think to risk as little as possible. Lady Scott will not exceed with ready money in her hand but calculating on the produce of a farm is different and neither she nor I are capable of that minute œconomy. Two cows should be all we should keep. But I find Lady S. inclines much for the farm. If she had her youthful activity and could manage it it would be well and would amuse her. But I fear it is too late a week.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00096"
    }
  }, [_vm._v("Returnd from Court by Constable, and found Cadell has fled to the Sanctuary"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-483",
      "id": "num-footnote-3-483-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" being threatend with ultimate diligence by the B. of S."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-484",
      "id": "num-footnote-4-484-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" about some "), _c('i', [_vm._v("£")]), _vm._v("1900 drawn out of their Cash accot. the day before the stop. If this be a vindictive measure it is harsh useless bad"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-485",
      "id": "num-footnote-5-485-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" of them, and flight on the contrary seems no good sign on his part. I hope he won’t prove his father or Grandfather at Prestonpans\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00009"
    }
  }, [_c('p', [_vm._v("And Cadell dressd amang the rest")]), _vm._v(" "), _c('p', [_vm._v("    Wi gun and good claymore, man,")]), _vm._v(" "), _c('p', [_vm._v("On gelding grey he rode that day")]), _vm._v(" "), _c('p', [_vm._v("    Wi pistols set before, man.")]), _vm._v(" "), _c('p', [_vm._v("The cause was gude he’d spend his blude")]), _vm._v(" "), _c('p', [_vm._v("    Before that he would yield, man,")]), _vm._v(" "), _c('p', [_vm._v("But the night before he left the corps")]), _vm._v(" "), _c('p', [_vm._v("    And never faced the field, man."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-486",
      "id": "num-footnote-6-486-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00098"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_91"
    }
  }, [_vm._v("Harden"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-487",
      "id": "num-footnote-1-487-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")]), _vm._v(" and Mrs. Scott calld on mamma. I was abroad. Henry"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-488",
      "id": "num-footnote-2-488-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" calld on me.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00099"
    }
  }, [_vm._v("Wrote only two pages (of manuscript) and a half to-day – As the boatswain said, one can’t dance always nowther. But were we sure of the quality of the stuff what opportunities for labour does this same system of retreat afford us. I am convinced that in three years I could do more than in the last ten but for the mine being I fear exhausted. Give me my popularity, "), _c('i', [_vm._v("an awful postulate")]), _vm._v(", and all my present difficulties shall be a joke in five years – and it is not lost yet at least.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00033"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00100"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Rose after a sound sleep and here am I without bile or any thing to perturb my inward man. It is just about three weeks since so great a change took place in my relations in society and already I am indifferent to it. But I have been always told my feelings of joy and sorrow, pleasure and pain, enjoyment and privation, are much colder than those of other people.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00010"
    }
  }, [_c('p', [_vm._v("I think the Romans call it stoicism."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-489",
      "id": "num-footnote-3-489-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Missie"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-490",
      "id": "num-footnote-4-490-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" was in the drawing room and over heard William Clerk and me laughing excessively at some foolery or other in the back room to her no small surprize which she did not keep to herself. But do people suppose that he was less sorry for his poor sister"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-491",
      "id": "num-footnote-5-491-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" or I for my lost fortune? If I have a very strong passion in the world it is "), _c('i', [_vm._v("pride")]), _vm._v(" and that never hinged upon world’s gear which was always with me Light come Light go.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00034"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00007"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MONDAY")]), _vm._v(" Letters received yesterday from Lord Montagu, John Morritt, and Mrs. Hughes"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-492",
      "id": "num-footnote-6-492-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" – kind and dear friends all with solicitous \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_92"
    }
  }, [_vm._v("enquiries. But it is very tiresome to have to tell my story over again and I really hope I have [no] more friends intimate enough to ask me for it. I detest letter writing and envy the Old Hermit of Prague who never saw pen or ink"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-493",
      "id": "num-footnote-1-493-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")]), _vm._v(" – What then! one must write; it is a part of the Law we live on. Talking of writing I finishd my six pages neat and handsome yesterday. N.B. At night I fell asleep and the oil dripd from the lamp upon my manuscript. Will this extreme unction make it go smoothly down with the public?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00011"
    }
  }, [_c('p', [_vm._v("Thus idly ‘we profane the sacred time’"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-494",
      "id": "num-footnote-2-494-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])])]), _vm._v(" "), _c('p', [_vm._v("By silly pun, light jest, and lighter rhyme.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00006"
    }
  }, [_vm._v("I have a song to write too and I am not thinking of it – I trust it will come upon me at once – A sort of catch it should be."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-495",
      "id": "num-footnote-3-495-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" I walkd out feeling a little overwrought. Saw Constable and turnd over Clarendon."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-496",
      "id": "num-footnote-4-496-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" Cadell not yet out of hiding. This is simple work.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00004"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("240 to John Gibson\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00007"
    }
  }, [_vm._v("Obliged to borrow "), _c('i', [_vm._v("£")]), _vm._v("240 to be repaid in Spring from John Gibson to pay my Nephew’s outfitt and passage to Bombay."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-497",
      "id": "num-footnote-5-497-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" I wish I could have got this money otherwise but I must not let the orphan boy and such a clever fellow miscarry through my fault. His education etc. has been at my expense ever since he came from America.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00035"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00101"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TUESDAY")]), _vm._v(" Had letters yesterday from Lady Davy"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-498",
      "id": "num-footnote-6-498-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" and Lady Louisa Stuart."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-499",
      "id": "num-footnote-7-499-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" Two very different persons. Lady Davy, daughter\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_93"
    }
  }, [_vm._v("an [d] coheiress of a wealthy Antigua Merchant, has been known to me all my life. Her father was a relation of ours of a Scotch calculation. He was of a good family, Kerr of Bloodielaws, but decayd. Miss Jane Kerr married first Mr. Apreece, Son of a Welch Baronet: The match was not happy. I had lossd all acquaintance with her for a long time when about twenty years ago we revived it in London. She was then a widow, gay, clever and most actively ambitious to play a distinguishd part in London society. Her fortune though handsome and easy was not large enough to make way by dint of showy entertainments and so forth so she took the "), _c('i', [_vm._v("blue")]), _vm._v(" line and by great tact and management actually establishd herself as a leader of literary fashion. Soon after, she resided in Edinburgh for a season or two and studied the Northern Lights. One of the best of them, poor Jack Playfair, was disposed ‘to shoot madly from his sphere’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-500",
      "id": "num-footnote-1-500-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")]), _vm._v(" and I believe askd her – but he was a little too old. She found a fitter husband in every respect in Sir Humphrey Davy"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-501",
      "id": "num-footnote-2-501-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" to whom she gave a handsome fortune and whose splendid talents and situation as President of the Royal Society gave her naturally a distinguishd place in the literary society of the Metropolis. Now this is a very curious instance of an active minded woman forcing her way to the point from which she seemd furthest excluded – for though clever and even witty she had no peculiar accomplishment and certainly no great taste either for science or letters naturally. I was once in the Hebrides with her"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-502",
      "id": "num-footnote-3-502-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" and I admired to observe how amid sea-sickness, fatigue, some danger, and a good deal of indifference as to what she saw, she gallantly maintaind her determination to see everything. It markd her strength of character and she joind to it much tact and always addressd people on the right side. So she stands high and deservedly so, for to these active qualities more French I think than English and partaking of the Creole vivacity and suppleness of character, she adds I believe honourable principles and an excellent heart – As a lion-catcher I could pit her against the world – She flung her "), _c('i', [_vm._v("lasso")]), _vm._v(" (see Hall’s "), _c('i', [_vm._v("South America")]), _vm._v(")"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-503",
      "id": "num-footnote-4-503-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" over Byron himself. But then, poor soul, she is not happy. She has a temper and Davy has a temper and these tempers are not one temper but two tempers and they quarrell like cat and dog, which may be good for stirring up the stagnation of domestic life but they let the world see it and that is not so well. Now in all this I may be thought a little harsh on my friend but it is \n          "), _c('a', {
    attrs: {
      "id": "pb-rw_94"
    }
  }, [_vm._v("between my Gurnal andme, and moreover I would cry heartily if anything were to ail my little cousin though she be addicted to rule the cerulean atmospher [e]. Then I suspect the cares of this as well as other empires overbalance its pleasures. There must be difficulty in being always in the right humour to hold a court. There are usurpers to be encounterd and insurrections to be put down –An incessant troop [of] bien-seances to be discharge [d], a sort of etiquette which is the curse of all courts – An old Lion cannot get ham-strung quietly at four hundred miles distance but the Empress must send him her condoleance and a pot of lip-salve. To be sure the monster is "), _c('i', [_vm._v("consanguinean")]), _vm._v(" as Sir Toby says."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-504",
      "id": "num-footnote-1-504-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00102"
    }
  }, [_vm._v("Lookd in at Constable’s coming home. Cadell emerged from Alsatia;"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-505",
      "id": "num-footnote-2-505-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" borrowd Clarendon."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-506",
      "id": "num-footnote-3-506-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00103"
    }
  }, [_vm._v("Home by ½ past 12. Much comfort in a stupid assistant. Sir R. D. and R. H."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-507",
      "id": "num-footnote-4-507-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" have two very clever men of business"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-508",
      "id": "num-footnote-5-508-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" whom the agents like and carry their business to these two offices to favour the Assistants. Mine, a good creature,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-509",
      "id": "num-footnote-6-509-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" only accomplishes the character of an Assistant so far as the three first letters go. So he gets fewer pence and I less trouble.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00104"
    }
  }, [_vm._v("My old friend Sir Peter Murray"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-510",
      "id": "num-footnote-7-510-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" calld to offer his own assistance, Lord Justice-Clerk’s and Abercromby’s to negotiate for me a seat upon the Bench instead of my Sheriffdom and Clerkship. I explaind to him the use which I could make of my pen was not I thought consistent with that situation, and that besides I had neglected the law too long to permit me to think of that situation. But this was kindly and honourably done. I can see people think me much worse of [f] than I think myself. They may be right. But I will not be beat till I have tried a rally and a bold one.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00036"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00105"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WEDNESDAY")]), _vm._v(" Slept ill, and rather bilious in the morning. Many of the Bench now are my Juniors. I will not seek "), _c('i', [_vm._v("ex elemosyna")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-8-511",
      "id": "num-footnote-8-511-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" a place which had I turnd my studies that way I might have aspired to long\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_95"
    }
  }, [_vm._v("ago "), _c('i', [_vm._v("ex meritis")]), _vm._v(". My pen should do much better for me than the odd "), _c('i', [_vm._v("£")]), _vm._v("1000 a year."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-512",
      "id": "num-footnote-1-512-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")]), _vm._v(" If it fails I will leave"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-513",
      "id": "num-footnote-2-513-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" on what they leave me. Another chance might be if it fails in the patronage which might after a year or two place me in Exchequer."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-514",
      "id": "num-footnote-3-514-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" But I do not count on this unless indeed the D. of B."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-515",
      "id": "num-footnote-4-515-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" when he comes of age should chuse to make play.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-right",
    attrs: {
      "id": "rw-block-sidebar_110266-00005"
    }
  }, [_c('p', [_c('i', [_vm._v("£")]), _vm._v("24 Lad [y] Scott\n            ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Got to my work again and wrote easier than the two last days. Gave Lady Scott her fortnight’s allowance "), _c('i', [_vm._v("£")]), _vm._v("24.0.0. The Laird of Harden made long visit. Spoke to Anne about a service for Dalgleish."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-516",
      "id": "num-footnote-5-516-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00106"
    }
  }, [_vm._v("Mr. Laidlaw came in from Abbotsford and dine [d] with us. We spent the evening in laying down plans for the farm"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-517",
      "id": "num-footnote-6-517-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" and deciding whom we should keep and whom dismiss among the people. This we did on the true negroe-driving principle of self-interest – the only principle I know which "), _c('i', [_vm._v("never")]), _vm._v(" swerves from its objects. We chose all the active young and powerful men, turning old age and infirmity adrift. I cannot help this for [one] guinea cannot do the work of five but I will contrive to make [it] easier to the sufferers.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00037"
    }
  }, [_c('p')]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00107"
    }
  }, [_vm._v("9 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THURSDAY")]), _vm._v(" A stormy morning lowering and blustering like our fortunes. "), _c('i', [_vm._v("Mea virtute me involvo")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-7-518",
      "id": "num-footnote-7-518-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" – But I must say to the Muse of fiction as the Earl of Pembroke said to the ejected Nun of Wilton ‘Go spin, you jade, go spin’ – Perhaps she has no "), _c('i', [_vm._v("tow")]), _vm._v(" on her "), _c('i', [_vm._v("rock")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-8-519",
      "id": "num-footnote-8-519-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00108"
    }
  }, [_vm._v(" When I was at Kilkenny last year we went to see a Nunnery but could not converse with the sisters because they were in strict retreat. I was delighted with the red-nosed padre who shewd us the place with a sort of proud unctuous humiliation and apparent dereliction of the world that had to me the air of a complete Tartuffe – a strong sanguine "), _c('a', {
    attrs: {
      "id": "pb-rw_98"
    }
  }, [_vm._v("square shoulderd son of the Church whom a protestant would be apt to warrant against any sufferings he was like to sustain by privation. My purpose however just now was to talk of the strict retreat which did not prevent the Nuns from walking in their little garden breviary in hand, peeping at us and allowing us to peep at them. Well – now we are in "), _c('i', [_vm._v("Strict Retreat")]), _vm._v(" and if we had been so last year instead of gallivanting to Ireland this affair might not have befallen if literary labour could have prevented it. But who could have suspected Constable’s timbers to have been rotten from the beginning?\n          ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_98"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00109"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_98"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_96"
    }
  }, [_vm._v("Visited the Exhibition on my way home from the Court. The new rooms are most splendid, and several good pictures. The institution"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-520",
      "id": "num-footnote-1-520-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")]), _vm._v(" has subsisted but five years and it is astonishing how much superior the worst of the present collection are to the tea-board looking things which first appeard. John Thomson of Duddingston"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-521",
      "id": "num-footnote-2-521-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" has far the finest picture in the Exhibitn. of a large size. Subject "), _c('i', [_vm._v("Dunluce")]), _vm._v(", a ruinous ca [s] tle of the Antrim family near the Giant’s causeway with one of those terrible seas and skies which only Thomson can paint. Found Scroop there improving a picture of his own, an Italian scene in Calabria. He is I think greatly improved and one of the very best amateur painters I ever saw – Sir George Beaumont"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-522",
      "id": "num-footnote-3-522-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" scarcely excepted. – Yet hang it I "), _c('i', [_vm._v("do")]), _vm._v(" except Sir George.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00110"
    }
  }, [_vm._v("I would not write to-day after I came home – I will not say "), _c('i', [_vm._v("could")]), _vm._v(" not for it is not true. But I was lazy: felt the desire "), _c('i', [_vm._v("far ’niente")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-523",
      "id": "num-footnote-4-523-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" which is the sign of one’s mind being at ease. I read "), _c('i', [_vm._v("The English in Italy")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-524",
      "id": "num-footnote-5-524-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" which is a clever book.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00111"
    }
  }, [_vm._v("Byron used to kick and frisk more contemptuously against the literary gravity and slang than any one I ever knew who had climbed so high – then it is true I never knew any one climb so high, and before you despise the eminence, carrying people along with you as convinced that you are not playing the fox and grapes, you must be at the top of the eminence. Moore told me two delightful stories of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_97"
    }
  }, [_vm._v("One was that while they stood at the window of Byron’s palazzo in Venice looking at a beautiful sun set Moore was naturally led to say something of its beauty when Byron answerd in a tone that I can easily conceive ‘Ah come d—n me, Tom, don’t be poetical.’ Another time standing with Moore on the balcony of the same palazzo a gondola passd with two English gentlemen who were easily distinguishd by their appearance. They cast a careless look at the balcony and went on. Byron crossd his arms and half stooping over the balcony said ‘Ah d—n ye if you had known what two fellows you were staring at you would have taken a longer look at us.’ This was the man – quaint capricious and playful with all his immense genius – He wrote from impulse never from effort and therefore I have always reckond Burns and Byron the most genuine poetical geniuses of my time and a half a century before me. We have however many men of high poetical talent but none I think of that ever gushing and perennial fountain of natural water.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_97"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_110266-00112"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_97"
    }
  }, [_vm._v("Mr. Laidlaw dined with us. Says Mr. G—n"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-525",
      "id": "num-footnote-1-525-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")]), _vm._v(" told him he would despair of my affairs were it any but S. W. S. No doubt – so should I and am wellnigh doing so at any rate – But "), _c('i', [_vm._v("fortuna juvante")]), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-526",
      "id": "num-footnote-2-526-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" much may be achieved. At worst the prospect is not very discouraging to one who wants little.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00113"
    }
  }, [_vm._v("Methinks I have been like Burns’s poor labourer")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00012"
    }
  }, [_c('p', [_vm._v("So constantly in Ruin’s sight")]), _vm._v(" "), _c('p', [_vm._v("The view o’t gives me little fright."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-527",
      "id": "num-footnote-3-527-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00114"
    }
  }, [_vm._v("10 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FRIDAY")]), _vm._v(" Went through for a new day the task of buttoning which seems to me somehow to fill up more of my morning than usual, not certainly that such is really the case but that my mind attends to the process having so little left to hope or fear. The half-hour between waking and rising has all my life proved propitious to any task which was exercizing my invention. When I get over any knotty difficulty in a story or have had in former times to fill up a passage in a poem it was always when I first opend my eyes that the desired ideas throngd upon me. This is so much the case that I amin the habit of relying upon it and saying to myself when I am [at] a loss ‘Never mind, we shall have it at seven o’clock tomorrow morning.’ If I have forgot a circumstance or a\n          name or a copy of verses it is the same thing. There is a passage about this sort of matutinal inspiration in the "), _c('i', [_vm._v("Odyssey")]), _vm._v(" which would make a handsome figure here if I could read or write Greek."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-528",
      "id": "num-footnote-1-528-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" I will look into Pope for it who ten to one will not tell me the real translation.\n          ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00115"
    }
  }, [_vm._v("I think the first hour of the morning is also favourable to the bodily strength. Among other feats when I was a young man I was able at times to lift a smith’s anvil with one hand by what is called the "), _c('i', [_vm._v("horn")]), _vm._v(" or round projecting piece of iron on which things are beaten to turn them round. But I could only do this before breakfast and shortly after rising. It required my full strength undiminishd by the least exertion and those who choose to try will find the feat no easy one.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00008"
    }
  }, [_vm._v("This morning I had some good ideas respecting "), _c('i', [_vm._v("Woodstock")]), _vm._v(" which will make the story better. The devil of a difficulty is that one puzzles the skean in order to excite curiosity and then cannot disentangle it for [the] satisfaction of the prying fiend they have raised.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00116"
    }
  }, [_vm._v("A letter from Sir James McIntosh"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-529",
      "id": "num-footnote-2-529-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" of condoleance prettily expressd and which may be sung to the old tune of Wellcome wellcome, brother Debtor."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-530",
      "id": "num-footnote-3-530-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" Another son of chivalry dismounted by mischance is sure to excite the compassion of one laid on the arena before him.\n         ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00117"
    }
  }, [_vm._v("Yesterday I had an anecdote from old Sir James Stewart Denham"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-531",
      "id": "num-footnote-4-531-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" which is worth writing down. His uncle Lord Elcho was as is well known engaged in the affair of 1745. He was dissatisfied with the conduct of matters from beginning to end. But after the left wing of the Highlanders was repulsed and broken at Culloden Elcho rode up to the Chevalier and told him all was lost and that nothing remaind except to charge at the head of two thousand men who were still unbroken and either turn the fate of the day or die sword in hand as became his pretensions. The Chevalier gave him some evasive answer and turning his horse’s head\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_99"
    }
  }, [_vm._v("rode off the field. Lord Elcho calld after him (I write the very words) ‘There you go for ad—ncowardlyb—g Italian’ and never would see him and never would see lost his property and remaind an exile inthe cause. Lord Elcho left two copies of his memoirs, one with Sir James Stewart’s family, one with Lord Wemyss."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-532",
      "id": "num-footnote-1-532-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_110266-00118"
    }
  }, [_vm._v("This is better evidence than the romance of Chevalier Johnstone."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-533",
      "id": "num-footnote-2-533-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" And I have little doubt it is true. Yet it is no proof of the prince’s cowardice though it shows him to have been no John of Gaunt."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-534",
      "id": "num-footnote-3-534-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" Princes are constantly surrounded with people who hold up their own "), _c('i', [_vm._v("life")]), _vm._v(" and "), _c('i', [_vm._v("safety")]), _vm._v(" to them as by far the most important stake in any contest and this is a doctrine in which conviction is easily received. Such an eminent person finds every bodie’s advice save here and there that of a desperate Elcho recommend obedience to the natural instinct of self preservation which very often men of inferior situations find it difficult to combat when all the world are crying to them to get on and be damnd instead of encouraging them to run away. At Preston-pans the Chevalier offerd to lead the van and he was with the Second line which during that brief affair followd the first very close. Johnstone’s own account, carefully re [a] d, brings him within a pistol shot of the first line. At the same time Charles Edward had not a head or heart for great things notwithstanding his daring adventure, and the Irish officers by whom he was guided were poor creatures. Lord George Murray"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-4-535",
      "id": "num-footnote-4-535-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" was the soul of the undertaking.\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-000034"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00009"
    }
  }, [_vm._v("11 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SATURDAY")]), _vm._v(" Court sate till half past one. I had but a trifle to do so wrote to Miss Maclean Clephane"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-5-536",
      "id": "num-footnote-5-536-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])]), _vm._v(" – and Nephew Walter. Sent the last "), _c('i', [_vm._v("£")]), _vm._v("40 in addition to "), _c('i', [_vm._v("£")]), _vm._v("240 sent on the 6th, making his full equipment "), _c('i', [_vm._v("£")]), _vm._v("280."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-6-537",
      "id": "num-footnote-6-537-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_100"
    }
  }, [_vm._v("A man calling himself Charles Gray of Carse wrote to me expressing sympathy for my misfortunes and offering me half the profits of what he calls the anti radical Laika which, if I understand him right, is a patent medicine"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-538",
      "id": "num-footnote-1-538-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")]), _vm._v(" to which I suppose he expects me to stand trumpeter. He endeavours to get over my objections to accepting his liberality (supposing me to entertain them) by assuring me his conduct is founded on a "), _c('i', [_vm._v("sage")]), _vm._v(" "), _c('i', [_vm._v("selfishness")]), _vm._v(". This is diverting enough – I suppose the Commissioners of police will next send me a letter of condoleance begging my acceptance of a broom a shovel and a scavenger’s great coat and assuring me that they had appointed me to all the emolument of a well frequented crossing – it would be doing more than they have done of late to the cleanliness of the streets which, witness my shoes, are in a piteous pickle. I thankd the Selfish Sage with due decorum for what purpose can anger serve? I remember once before a mad woman from about Alnwick, by [name] Latin or Laytoun,"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-539",
      "id": "num-footnote-2-539-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" baited me with letters and plans – first for charity to herself or some protegee – I gave my guinea – then she wanted to have half the profit of a novel which I was to publish under my name and auspices – She sent me the manuscript and a "), _c('i', [_vm._v("moving")]), _vm._v(" tale it was for some of the scenes lay in the "), _c('i', [_vm._v("Cabinet a l’eau")]), _vm._v(". I declined the partnership. Lastly my fair correspondent insisted I was a lover of speculation and would be much profited by going shares in a patent medicine which she had invented for the benefit of little babies I believe. I declined to have anything to do with such a Herod-like affair and beggd to decline the honour of correspondence in future. I should have thought the thing a quiz but that the novel was real and substantial.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00011"
    }
  }, [_vm._v("Anne goes to Ravelston"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-540",
      "id": "num-footnote-3-540-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" to-day to remain tomorrow.\n         ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_110266-00012"
    }
  }, [_vm._v("Sir Alexr. Don calld and we had a good laugh together.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_110266-00038"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_110266-00120"
    }
  }, [_vm._v("12 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SUNDAY")]), _vm._v(" Having ended the Second Vol of "), _c('i', [_vm._v("Woodstock")]), _vm._v(" last night I have to begin the Third this morning. Now I have not the slightest idea how the story is to be wound up to a catastrophe. I am just in the same case as I used to be when I lost myself in former days in some country to which I was a stranger – I always pushd for the pleasantest road and either found or made it the nearest. It is the\n          "), _c('a', {
    attrs: {
      "id": "pb-rw_101"
    }
  }, [_vm._v("same in writing. I never could lay down a plan – or having laid it down I never could adhere to it; the action of composition always dilated some passages and abridged or omitted others and personages were renderd important or insignificant not according to their agency in the original conception of the plan but according to the success or otherwise with which I was able to bring them out. I only tried to make that which I was actually writing diverting and interesting, leaving the rest to fate. I have been often amused with the critics distinguishing some passages as particularly labourd when the pen passd over the whole as fast as it could move and the eye never again saw them excepting in proof. Verse I write twice and sometimes three times over. This may be calld in Spanish the "), _c('i', [_vm._v("Der donde diere")]), _vm._v(" mode of composition – in English "), _c('i', [_vm._v("Hab nab at a")]), _vm._v(" venture. It is a perilous stile I grant but I cannot help [it] – when I chain my mind to ideas which are purely imaginative – for argument is a different thing – it seems to me that the sun leaves the landscape, that I think away the whole vivacity and spirit of my original conception, and that the results are cold, tame and spiritless. It is the difference between a written oration and one bursting from the unpremed [it] ated exertions of the Speaker which have always something the air of enthusiasm and inspiration. I would not have young authors imitate my carelessness however – "), _c('i', [_vm._v("consilium non")]), _vm._v(" "), _c('i', [_vm._v("currum cape")]), _vm._v(" – "), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-1-541",
      "id": "num-footnote-1-541-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")]), _vm._v("\n          Read a few page of Will D’Avenant who was fond of having it supposed that Shakespeare intrigued with his mother. I think the pretension can only be treated as Phaeton’s was according to Fielding’s farce. ")]), _vm._v(" "), _c('div', {
    staticClass: "block stanza",
    attrs: {
      "id": "rw-block-stanza_110266-00013"
    }
  }, [_c('p', [_vm._v("Besides by all the village boys I’m sham’d,")]), _vm._v(" "), _c('p', [_vm._v("You the Sun’s son, you rascal? – you be damnd.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_110266-00010"
    }
  }, [_vm._v("Egad I’ll put that into "), _c('i', [_vm._v("Woodstock")]), _vm._v("."), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-2-542",
      "id": "num-footnote-2-542-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" It might come well from the old admirer of Shakspeare –"), _c('span', {
    staticClass: "ref-footnote"
  }, [_c('span', {
    attrs: {
      "href": "#/9781847674951_chapter_05_05#num-footnote-3-543",
      "id": "num-footnote-3-543-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" then Fielding’s lines were not written – what then it is an anachronism for some sly rogue to detect. Besides it is easy to swear they were written and that fielding adopted them from tradition.\n         ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-223bafbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674951_chapter_05.vue
// module id = 90
// module chunks = 0